import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

/**
 * Traveler-facing booking flow. The previous version of this section walked a venue
 * through onboarding (assessment, installation, revenue activation, management);
 * that material is covered by "How the pods run" on /pods/ and does not belong in
 * the consumer path.
 */

const steps = [
  {
    number: "01",
    title: "Find a pod",
    description:
      "Choose your venue and see which pods are available, whether you are on a show floor or in a hotel lobby.",
  },
  {
    number: "02",
    title: "Book your time",
    description:
      "Reserve ahead from your phone, or walk up and tap to pay at the pod, for thirty minutes or a few hours.",
  },
  {
    number: "03",
    title: "Enter your PIN",
    description:
      "We email your PIN when you book. Enter it at the pod and the door opens. No key and no front desk.",
  },
  {
    number: "04",
    title: "Get to work",
    description:
      "Power, fast charging, Wi-Fi, and fresh air, in a room quiet enough to hear each other.",
  },
];

const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-20 md:py-28 bg-secondary">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <SectionHeading eyebrow="How it works" title="From chaos to a closed door in under a minute" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-12">
          {steps.map((step, i) => (
            <Reveal key={step.number} delay={i * 80}>
              <div className="border-t border-quietcove-blue/15 pt-6">
                <div className="font-display text-4xl font-bold text-gold/85 mb-5 tracking-[-0.02em]">
                  {step.number}
                </div>
                <h3 className="font-display text-xl font-bold tracking-[-0.015em] text-quietcove-blue mb-3">
                  {step.title}
                </h3>
                <p className="text-quietcove-grey leading-relaxed">{step.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
